import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import DialogModal from '../../common/DialogModal';

const styles = theme => ({
  text: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },

  button: {
    border: 'solid 1px #D8DBDF',
    color: '#181819',
    fontSize: '13px',
    margin: '30px',
  },

  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
  },

  contentContainer: {
    margin: 0,
    padding: '20px 115px',
    textAlign: 'unset',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
});

class FollowCallOrderCompleteDialog extends React.Component {
  render() {
    const { classes, isOpen, toggleDialog, buttonText } = this.props;

    return (
      <DialogModal
        title="フォローコール注文完了"
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <img alt="注文完了" src={require('../../../assets/images/create-campaign-completed@2x.png')} height="300" />

        <Typography variant="subheading" style={{ fontWeight: 'bold', marginTop: '30px' }}>注文を承りました</Typography>

        <Button color="default" onClick={toggleDialog} className={classes.button}>
          {buttonText ? buttonText : 'タイムラインを確認'}
        </Button>
      </DialogModal>
    );
  }
}

FollowCallOrderCompleteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  buttonText: PropTypes.string
};

export default withStyles(styles)(FollowCallOrderCompleteDialog);



// WEBPACK FOOTER //
// ./src/components/Timeline/dialogs/FollowCallOrderCompleteDialog.jsx